import request from "@/utils/request";

// 查询抽奖专场内容
export function getLotteryPlaceDetail() {
  return request({
    url: "/product/award/h5/award/act",
    method: "get",
  });
}
// 查询抽奖专场列表
export function getLotteryPlaceList() {
  return request({
    url: "/product/special-award/h5/list",
    method: "get",
  });
}
// 获取九宫格商品列表
export function getOverlayList() {
  return request({
    url: "/product/award/h5/list",
    method: "get",
  });
}
// 抽奖次数
export function getOverlayCount() {
  return request({
    url: "/product/award/award/num",
    method: "get",
  });
}
// 获取抽奖结果
export function getOverlayResult() {
  return request({
    url: "/product/award/draw/award",
    method: "get",
  });
}
